const config = {
  apiGateway: {
    REGION: 'eu-west-1',
    INTERNAL_API_URL: 'https://sh0qcol8m4.execute-api.eu-west-1.amazonaws.com/prod',
    TARGET_API_URL: 'https://jd8f2q3d6d.execute-api.eu-west-1.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.europe.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.europe.forwoodsafety.com'
  }
};

export default config;